<template>
    <div>
        <div class="uk-padding">
            <div class="uk-container">
                <h1 class="uk-text-center">College of Natural & Applied Sciences, Allied Health & Nursing</h1>
                <hr>
                <h2 class="uk-text-left" >Message from the Dean
                    <span class="uk-text-muted uk-text-small uk-text-italic" style="font-variant: none !important;"> Professor Vincent Wright</span>
                </h2>
                <div class="uk-panel">

                    <img class="uk-border-pill uk-align-left@m" src="../assets/vincentwright1.jpg" width="150" height="150" alt="Border pill">

                    <p>
                        It is my pleasure to welcome you to the NCU College of Natural and Applied Sciences, Allied Health
                        and Nursing! This super-college comprises seven departments: Biology, Chemistry and
                        Environmental Sciences; Mathematics and Engineering; Computer and Information Sciences;
                        Medical Technology; Dental Hygiene; Dietetics and Nutrition; and Nursing. NCU is fully accredited by
                        the University Council of Jamaica (UCJ) and the Adventist Accrediting Association (AAA) in the USA,
                        therefore, all the programmes offered in our college are fully accredited by these bodies. You will
                        find that the College offers exciting opportunities for students to pursue meaningful careers that will
                        propel them into the world of innovation and evolving sciences, health care, and technology. Our
                        curricula not only put theory into practice, but they integrate the tenets of the Christian faith with
                        learning; thereby, fulfilling the Mission of Northern Caribbean university to equip each student for
                        “committed professional service to all people and to God”.
                    </p>
                    <p>
                        Our College has a team of professional, talented and dedicated faculty members who are up to date
                        with their instructional materials and technology and can effectively deliver courses through
                        distance, remote and face-to-face modalities; the current COVID-19 Pandemic has proven that
                        reality. The faculty members and students in the various departments have been involved in
                        ground-breaking research in the areas of nutraceuticals, environmental sciences, microbiology, and
                        medical technology; the findings from these research address real life issues and have been
                        published in peer reviewed journals Faculty members in our engineering department have used
                        renewable energy technology to provide wind and solar energy on a small scale on the campus and
                        they have built small equipment to assist farmers in agri-processing. Farmers in Jamaica have
                        benefited from the products and services offered through our Agriculture and environmental science
                        departments, Agri-processing laboratory, and Tissue-culture laboratory. Faculty members from the
                        Department of Biology, Chemistry and Environmental Science have completed several projects to
                        restore mined out bauxite lands and the restoration of watershed areas in Jamaica.
                    </p>
                    <p>
                        The Computer and Information Science Department with its newly established robotics laboratory
                        offers several programmes which allow for exciting careers in computer and information sciences.
                        The students and faculty in this department are recipients of many local and international awards in
                        computer science.
                    </p>
                    <p>
                        Our nursing programme is among the most subscribed programme in the college. Students in this
                        department get the opportunity to blend theory with practice through simulation laboratory and
                        clinical practice in the leading specialised hospitals in Jamaica. The NCU student nurses are among
                        the top students in the Regional Examinations for Nurse Registration (RENR) and the graduates are
                        among those that are highly sought after by recruiters.
                    </p>
                    <p>
                        Our capable and supportive faculty are not only involved in classroom learning and research, but
                        they are also highly involved in community service. Annually, the Dental Hygiene Department in
                        collaboration with overseas universities give free dental care to the community and our Nutrition
                        and Dietetics faculty give consultation on healthy lifestyle practices.
                    </p>
                    <p>
                        Sincerely <br>
                        Professor Vincent Wright <br>
                        Dean of the College of Natural and Applied Sciences Allied Health and Nursing
                    </p>
                </div>
            </div>
        </div>
        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <h2 class=" uk-text-bold uk-text-center uk-text-capitalize " style="font-variant: normal !important;">College Research</h2>
                <p class="uk-text-small uk-text-center">Here is just a taste of the research that we have done</p>
                <div class="uk-child-width-1-4@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                <img src="../assets/Patience_Alonge.png" alt="">
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title uk">Prof Patience Alonge</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m">
                                        <b>Publications:</b>
                                    </div>
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        International Journal of Healthcare Sciences ISSN 2348-5728 (Online) Vol. 6,
                                        <br>
                                        Issue 1, pp: (166-170), Month: April - September 2018,
                                        <br>Available at: www.researchpublish.com
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                <img src="../assets/Max1.jpg" alt="">
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">M. Wellington</h3>
                                <ul class="uk-list uk-list-bullet uk-text-small">
                                    <b>Comparative nutritional analysis of:</b>
                                    <li>Themeda arguens (Piano Grass)</li>
                                    <li>Brachiaria decumbens (Signal Grass)</li>
                                    <li>Cynodonnlemfuensis (African Star)</li>
                                </ul>
                                <div class="uk-text-small" uk-grid>
                                    <div class="uk-width-1-1@m">
                                        <b>Published:</b>
                                    </div>
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        Accepted to Jamaican Journal of
                                        Science & Technology, November 2017
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                <img src="../assets/Mark1.jpg" alt="">
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">Prof. Mark Harris</h3>
                                <div class="uk-text-small" uk-grid>
                                    <div class="uk-width-1-1@m">
                                        <b>Published:</b>
                                    </div>
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        <b class="uk-text-muted">Confronting Global Climate Change: Experiments & Applications in the Tropics 2019</b><br><br>
                                        This book has chapters written by other faculty members including fellow
                                        department colleagues Dwight Rose and Deshaun Martin-Clarke
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                <img src="../assets/Rose1.jpg" alt="">
                            </div>
                            <div class="uk-card-body uk-padding-small">
                                <h3 class="uk-card-title">Dwight Rose</h3>
                                <div class="uk-text-small uk-margin-remove-top" uk-grid >
                                    <div class="uk-width-1-1@m">
                                        <b>Publications:</b>
                                    </div>
                                    <div class="uk-width-1-1@m uk-margin-remove-top">
                                        “Environmental Health, Use of Banana and Plantain Leaves for Manufacture of Hand-
                                        Made Paper”
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<cnas-degrees/>-->
        <cnas-department-links/>

        <div class="uk-padding uk-background-muted">
            <div class="uk-container uk-container-large">
                <h3 class="uk-heading-bullet uk-text-bold">Top Achievers</h3>
                <p class="uk-text-small">Students that excelled the past semester</p>
                <div class="uk-child-width-1-4@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Elizabeth Burton </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li><span class="uk-text-small"> Biological Science:</span> <span class="uk-text-bold">Freshman</span>
                                            <br>
                                            <span class="uk-text-small"> GPA:</span> <span class="uk-text-bold">3.65</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Gavaskia Smith </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li><span class="uk-text-small"> Biological Science:</span> <span class="uk-text-bold">Senior </span>
                                            <br>
                                            <span class="uk-text-small"> GPA:</span> <span class="uk-text-bold">3.80</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Sanjay Reid </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li><span class="uk-text-small"> Biological Science:</span> <span class="uk-text-bold">Junior</span>
                                            <br>
                                            <span class="uk-text-small"> GPA:</span> <span class="uk-text-bold">3.61</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Merdonna Scott</dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li><span class="uk-text-small"> Biological Science:</span> <span class="uk-text-bold">Senior</span>
                                            <br>
                                            <span class="uk-text-small"> GPA:</span> <span class="uk-text-bold">3.66</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                </div>
            </div>



        </div>
        <cnas-success-story/>
        <div class="uk-padding ">
            <div class="uk-container uk-container-large">
                <h3 class="uk-heading-bullet">Get in touch with us</h3>
                <div class="uk-child-width-1-3@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Vincent Wright (Dean) </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li>Phone: <span class="uk-text-small"> Internal:</span> <span class="uk-text-bold">7482</span>
                                            <br>
                                            <span class="uk-text-small"> External:</span> <span class="uk-text-bold">1-876-963-7482</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Dr. Erica Robinson-Sturridge (Associate Dean) </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li>Phone: <span class="uk-text-small"> Internal:</span> <span class="uk-text-bold">7238</span>
                                            <br>
                                            <span class="uk-text-small"> External:</span> <span class="uk-text-bold">1-876-963-7238</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Antoinette Parchment </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li>Phone: <span class="uk-text-small"> Internal:</span> <span class="uk-text-bold">7479</span>
                                            <br>
                                            <span class="uk-text-small"> External:</span> <span class="uk-text-bold">1-876-963-7479</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                </div>
            </div>



        </div>
        <explore-undergrad-programs/>
    </div>
</template>

<script>
    import CnasDepartmentLinks from "../components/colleges/cnas/departmentLinks";
    import cnasSuccessStory from "../components/colleges/cnas/successStory";
    import ExploreUndergradPrograms from "../components/undergradadmission/exploreUndergradPrograms";
    import CnasDegrees from "../components/colleges/cnas/cnasDegrees";

    export default {
        name: "CNAS",
        components: {CnasDegrees, ExploreUndergradPrograms, cnasSuccessStory, CnasDepartmentLinks}
    }
</script>

<style scoped>
    h2 {
        font-variant: all-small-caps;
        font-size: xx-large;
        color: #033860;
        font-weight: bolder;
    }
    dt{
        color: #033860;
        font-weight: bolder;
        font-size: large;
    }
</style>